<template>
  <v-app v-if="$isUserRoleGreaterThan('sales_associate_back')">
    <v-app-bar>
      <v-toolbar-title>Hermès devis mobilier</v-toolbar-title>
      <v-toolbar-items>
        <v-btn flat>
          Products
        </v-btn>
        <v-btn flat>
          Quotes
        </v-btn>
        <v-btn flat>
          Countries
        </v-btn>
        <v-btn flat>
          Stores
        </v-btn>
        <v-btn flat>
          Users
        </v-btn>
        <v-btn icon>
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>	
    <v-main class="ma-5">
      qsqsdjqlkj
      <NuxtPage/>
    </v-main>
  </v-app>
</template>